import React, { useState, useEffect, lazy, Suspense } from "react";
import { useTestContext } from "../context/TestContext";

// Imports
import TitleText from "./TitleText";
//import Pagination from "./Pagination";
const ProductCard = lazy(() => import("./ProductCard"));

const RadiologyProducts = () => {
  const {
    fetchRadiologyProducts,
    radiologyProducts,
    radiologyProductsPagination,
    popularProducts,
  } = useTestContext();
  const [currentPage, setCurrentPage] = useState(1);

  const filteredProducts = popularProducts
  .filter(
    (product) =>
      (product.brandName === "Pathkind Labs" || product.brandName === "Dr Lal PathLabs") &&
      product.productType === "Radiology"
  )
  .sort((a, b) => {
    const cleanBrandA = a.brandName.replace(/[\r\n]+/g, '').trim();
    const cleanBrandB = b.brandName.replace(/[\r\n]+/g, '').trim();

    const isDrLalA = cleanBrandA === "Dr Lal PathLabs";
    const isDrLalB = cleanBrandB === "Dr Lal PathLabs";

    // Prioritize "Dr Lal PathLabs" first
    if (isDrLalA && !isDrLalB) return -1;
    if (!isDrLalA && isDrLalB) return 1;

    // If both are from the same brand, sort by price ascending
    const priceA = parseFloat(a.sellingPrice.replace(/,/g, ''));
    const priceB = parseFloat(b.sellingPrice.replace(/,/g, ''));
    return priceA - priceB;
  });


  useEffect(() => {
    fetchRadiologyProducts(currentPage);
  }, [currentPage]);

  return (
    <div className="w-full h-fit bg-whiteColor flex flex-col justify-start items-center p-[3%] lg:px-[6.5%] lg:py-[2%] space-y-[5%] lg:space-y-[2%]">
      <div className="w-[92.5%] h-fit flex justify-between items-center">
        <TitleText text="Popular X-Ray and Scans" />
      </div>
      <div className="w-[95%] h-fit grid grid-cols-1 lg:grid-cols-3 gap-x-0 gap-y-3 lg:gap-y-8 mx-auto justify-items-center">
        <Suspense
          fallback={
            <div className="w-full h-fit flex justify-center items-center">
              <span className="font-normal text-[7.5vw] lg:text-[1.25vw] text-textPrimaryColor">
                Loading radiology products...
              </span>
            </div>
          }
        >
          {filteredProducts?.map((item, index) => (
            <ProductCard data={item} key={index} />
          ))}
        </Suspense>
      </div>
    </div>
  );
};

export default RadiologyProducts;
